import React from 'react';

const nombre = (valeur, decimales = 0) => new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: decimales,
  maximumFractionDigits: decimales
}).format(Number(valeur) || 0);

/**
 * Le calcul du prorata, ecrit en toutes lettres.
 *
 * La gestionnaire ne doit pas avoir a faire confiance a un montant tombe du
 * ciel : en voyant la regle appliquee a son cas, elle la retient et peut la
 * refaire de tete devant un parent qui conteste.
 *
 * La formule affichee est celle reellement executee - tarif x jours presents
 * divise par jours du mois - et non une version simplifiee : un « prix par
 * jour » arrondi ne redonnerait pas le meme total.
 */
const CalculProrata = ({ montantPlein, joursPresents, joursDuMois, montantProrata }) => {
  const exact = joursDuMois > 0 ? (Number(montantPlein) || 0) * joursPresents / joursDuMois : 0;
  const arrondi = Math.abs(exact - montantProrata) > 0.004;

  return (
    <span className="mt-2 block rounded-md border border-[#cfe3ec] bg-[#eef7fb] px-2.5 py-2">
      <span className="block text-[11px] font-semibold text-[#246990]">
        {nombre(montantPlein)} × {nombre(joursPresents)} ÷ {nombre(joursDuMois)} = {nombre(montantProrata)} FCFA
      </span>
      <span className="mt-1 block text-[10px] leading-snug text-gray-600">
        Tarif du mois × jours de présence ÷ jours du mois.
        {arrondi && ` Soit ${nombre(exact, 2)}, arrondi au franc le plus proche.`}
      </span>
    </span>
  );
};

export default CalculProrata;
